<template>
  <div class="upload">
    <ul class="upload-images">
      <li class="uploaded-file" v-if="file">
        <v-img :src="getExt(selectFile) ? imageURL : fileIcon" aspect-ratio="1" @click="lightbox" contain>
          <template v-slot:placeholder>
            <v-layout fill-height align-center justify-center ma-0>
              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </v-layout>
          </template>
        </v-img>
      </li>
      <li class="file-select" @click.stop="onFocus" v-if="!disabled && !selectFile">
        <v-layout fill-height align-center justify-center row>
          <div v-if="!uploading">
            <v-icon large>fas fa-cloud-upload-alt</v-icon>
          </div>
          <div v-else>
            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
          </div>
        </v-layout>
      </li>
    </ul>
    <input ref="fileInput" type="file" :accept="accept" @change="onFileChange" />
    <div class="mask">
      <ul class="list-inline">
        <li v-if="!disabled && file">
          <v-icon @click.stop="storageFileDelete(selectFile)">fas fa-trash-alt</v-icon>
        </li>
        <li v-if="deletable">
          <v-icon @click.stop="componentDelete">fas fa-minus-square</v-icon>
        </li>
      </ul>
    </div>
    <div>
      <v-chip
        class="label"
        :color="labelEditable ? 'light-blue darken-3' : 'blue-grey lighten-2'"
        @click.stop="labelEdit"
        dark>
          {{ fileName }}
        </v-chip>
    </div>
    <!-- 編集ダイアログ -->
    <v-dialog v-model="dialog" persistent max-width="480">
      <v-card>
        <v-card-title class="dialog-header">
          <span class="title font-weight-light">名称の設定</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            label="名称"
            v-model="editedItem.label"
            outlined hide-details="auto">
          </v-text-field>
        </v-card-text>
        <v-card-actions class="dialog-footer">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.stop="labelChange" depressed>
            <v-icon left>fas fa-save</v-icon>設定
          </v-btn>
          <v-btn @click="dialog = false" depressed>
            <v-icon left>fas fa-times</v-icon>閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Storage } from 'aws-amplify'
import moment from 'moment'
import imageCompression from 'browser-image-compression'

export default {
  data() {
    return {
      uploading: false,
      progress_value: 0,
      imageURL: null,
      fileIcon: require('@/assets/document.png'),
      dialog: false,
      editedItem: {
        label: null,
      },
    }
  },
  props: {
    label: {
      type: String,
      default: '名称未設定',
    },
    labelEditable: {
      type: Boolean,
      default: false,
    },
    deletable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    file: {
      type: String,
      default: null,
    },
    accept: {
      type: String,
      default: 'image/*',
    }
  },
  created() {
    if (this.file) this.getImageURL(this.file)
  },
  watch: {
    selectFile(val) {
      !val || this.getImageURL(val)
    },
  },
  computed: {
    selectFile: {
      get() {
        return this.file
      },
      set(value) {
        this.$emit('update:file', value)
      },
    },
    fileName: {
      get() {
        return this.label
      },
      set(value) {
        this.$emit('update:label', value)
      },
    }
  },
  methods: {
    onFocus() {
      if (!this.readonly) {
        this.$refs.fileInput.click()
      }
    },
    async onFileChange($e) {
      try {
        const path = this
        const files = $e.target.files || $e.dataTransfer.files
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        }
        if (files) {
          if (files.length > 0) {
            this.progress_value = 0
            this.uploading = true

            //画像の圧縮
            let uploadFile = null
            if (this.getExt(files[0].name)) {
              uploadFile = await imageCompression(files[0], options);
            } else {
              uploadFile = files[0]
            }

            //ファイルアップロード
            const newFile = 'uploads/' + moment().format('YYYY/MM/') + this.getUniqueName(files[0].name)
            const ret = await Storage.put(newFile, uploadFile, {
              progressCallback(progress) {
                path.progress_value = (progress.loaded, progress.total) * 100
              }
            })
            this.$emit('uploadFile')

            this.selectFile = ret.key
            this.uploading = false
          }
        }
      } catch(e) {
        console.log(e)
      }
    },
    storageFileDelete() {
      this.selectFile = null
      this.imageURL = null
    },
    lightbox() {
      this.$emit('lightbox', this.imageURL)
    },
    async getImageURL(key) {
      try {
        const ret = await Storage.get(key)
        this.imageURL = ret
      } catch(e) {
        console.log(e)
      }
    },
    getExt(fileName) {
      const imageExt = ['jpg', 'jpeg', 'png', 'gif']

      let pos = fileName.lastIndexOf('.')
      if (pos === -1) return false

      let ext = fileName.slice(pos + 1)
      pos = ext.indexOf('?')

      if (pos !== -1) ext = ext.slice(0, pos)

      return imageExt.find(e => e === ext.toLowerCase()) ? true : false
    },
    //ラベルの変更ダイアログ表示
    labelEdit() {
      if (this.labelEditable) {
        this.editedItem.label = this.fileName
        this.dialog = true
      }
    },
    //ラベルの変更
    labelChange() {
      this.fileName = this.editedItem.label
      this.dialog = false
      this.$emit('uploadFile')
    },
    //削除
    componentDelete(item) {
      this.$emit('deleteFile', item)
    },
  }
}
</script>

<style lang='scss' scoped>
.upload {
  display: inline-block;
  position: relative;
  input[type=file] {
    position: absolute;
    top: 0;
    left: -9999px;
  }
  ul.upload-images {
    list-style: none;
    margin: 0;
    padding: 0;
    li {
      display: inline-block;
      width: 120px;
      height: 120px;
      vertical-align: top;
      &.file-select {
        border: 1px solid #CCC;
        border-radius: 5px;
        cursor: pointer;
      }
      &.uploaded-file {
        position: relative;

      }
      .v-image {
        border-radius: 5px;
      }
    }
  }
  .mask {
    display: none;
    content: "";
    position: absolute;
    top: 5px;
    right: 2px;
    z-index: 1;
    border-radius: 5px;
    ul {
      li {
        margin: 0 5px;
        button {
          text-shadow: 0 0 5px #FFFFFF, 0 0 5px #FFFFFF;
        }
      }
      &:hover {
        cursor: pointer;
      }
    }
  }
  &:hover {
    .mask {
      display: block;
    }
  }
  .label {
    text-align: center;
    font-size: 12px;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: rgba(0, 0, 0, .5);
    color: #FFF;
    border-radius: 0 0 5px 5px;
  }
  &:hover {
    cursor: pointer;
  }
}
</style>
